function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 11.5V4H6V11.4091M14 11.5L16 10.5V16H4V10.5L6 11.4091M14 11.5L10 13L6 11.4091",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 7H12",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/outbox.338e77fa.svg";
export { SvgComponent as ReactComponent };